import setLoading from "components/loading";
import snackbar from "components/snackbar";
import { tagColors, getRandomValue } from "utils";
import { trainingTagsModalDefaultValue } from "../../types";

export const MAX_VIDEO_TAG_LENGTH = 25;

export const validateTag = ({ state }) => {
  let errors = {};
  const { tag } = state;

  if (!tag) {
    errors = { ...errors, tagError: "This filed is required." };
  }

  if (!!tag && tag.length > MAX_VIDEO_TAG_LENGTH) {
    errors = {
      ...errors,
      tagError: `Tag cannot be more than ${MAX_VIDEO_TAG_LENGTH} characters long.`,
    };
  }

  if (Object.keys(errors).length) {
    const withErrors = { ...errors, hasError: true };
    return withErrors;
  }

  return { ...errors, hasError: false };
};

export default {
  "ModalBody.Wrapper.ColorsWrapper.TagColorSelect": ({ color }, stateManager) =>  {
    stateManager.setSelectedColor(color)
  },
  "ModalBody.Wrapper.Tag": ({ trainingTagsModal, value }, stateManager) => {
    stateManager.setTrainingTagsModal({
      ...trainingTagsModal,
      tag: value,
      tagError: "",
    });
  },
  "ModalBody.ButtonWrapper.Button": async (
    { trainingTagsModal, selectedColor, trainingVideoModal, singleVideo },
    stateManager
  ) => {
    const { hasError, ...errors } = validateTag({ state: trainingTagsModal });
    if (hasError) {
      await stateManager.set({
        trainingTagsModal: {
          ...trainingTagsModal,
          ...errors,
        },
      });

      return;
    }

    try {
      setLoading(true);
      const res = await stateManager.saveVideoTag({
        name: trainingTagsModal.tag,
        color: selectedColor || getRandomValue({ tragetArray: tagColors }),
      });
  
      const tagsResponse = await stateManager.fetchVideoTag();
      const tags = tagsResponse.data.map((tag) => ({
        id: tag.id,
        display: tag.name,
        text: tag.name,
        color: tag.color,
      }));
      stateManager.set({
        singleVideo: {
          ...singleVideo,
          selectedTags: singleVideo?.selectedTags ? [...singleVideo?.selectedTags, res.data.id]: [res.data.id],
        },
        trainingVideoModal: {
          ...trainingVideoModal,
          selectedTags: trainingVideoModal?.selectedTags ? [...trainingVideoModal?.selectedTags, res.data.id] : [res.data.id]
        },
        isOpenTagsDropdown: true,
        videoTag: tags,
        trainingTagsModal: {
          ...trainingTagsModalDefaultValue,
          isVisible: false,
        },
      });
    } catch (e) {
      setLoading(false);
      snackbar({
        message: e?.response?.data?.error || "Something went wrong",
        args: { type: "error" },
      });
    }
    
  },
};
